
export default {
  name: '',
  //进入的是什么管理系统
  data() {
      return {
        // 表格数据
        studnetData:[
          {name:'123',idcard:35425},
          {name:'123',idcard:35425},
          {name:'123',idcard:35425},
        ],
        // 总条数
        studentTotal: 0,
        // 修改弹窗
        dialogFormVisible: false,
        //修改弹窗信息
        form:{
          name: 213,
          idcard: 234
        },
        // 当前页数
        currentPage: 1,
        // loading状态
        fullscreenLoading:false,
        //表单的样式宽度
        formLabelWidth: "120px",
        // 卡片数据
        forms:{name: "",
          idcard: ""},
        top:'top',
        // 班级详情
        classData:[
          {name:234,
          }
        ],
        // 班级详情弹窗
        dialogTableVisible2: false,

      }
  },
  methods: {
    // 修改弹窗
    updateStuInfo(row){
      this.dialogFormVisible = true;
    },
    //修改
    edit(){
      this.dialogFormVisible = false;
      let data = {};
      this.$post('', data).then(res => {
        // // console.log(res);
        if (res.data.status == 'success') {
          this.dialogUpdatetVisible = false;
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success'
          });
          this.getdata();
        } else {
          this.$message({
            showClose: true,
            message: '修改失败',
            type: 'error'
          });
        }
      })
    },
    //获取班级详情
    getClass(){
      this.$post('', { token: this.$store.state.id, offset: this.studentCurrentPage, length: this.pageLen, shop_id: this.$store.state.store.id }).then(res => {
        this.studentTotal = res.data.result.total;
        this.studnetData = res.data.result.data;
				this.fullscreenLoading = false
      })
    },
    //分页页数变动事件
    getStudentPage(){

    },
    //页面条数变动事件
    handleSizeChange(){

    },
    //班级详情弹窗
    lookStuInfo(row){
      this.dialogTableVisible2 = true;
    },
    //获取表格数据
    getdata(){
      // this.fullscreenLoading = true
      this.searchType = true;
      this.$post('', { token: this.$store.state.id, offset: this.studentCurrentPage, length: this.pageLen, shop_id: this.$store.state.store.id }).then(res => {
        this.classData = res.data.result.data;
				// this.fullscreenLoading = false
      })
    }
  },
  created() {
     this.getdata();
  }
}
